import React from "react";
import PropTypes from "prop-types";
import Lottie from "lottie-react";
import animationData from "../Assests/daiLogoAnimation.json";

const LogoAnimation = ({ width = "11vh", height = "11vh", style = {} }) => {
  return (
    <Lottie
      animationData={animationData}
      loop={true}
      style={{ width, height, ...style }}
    />
  );
};

LogoAnimation.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
};

export default LogoAnimation;